import instance, { ADMIN_PREFIX } from 'services/api';

export interface MeetingRoomResult {
  password: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

/**
 * POST /meetings/create-room — provisions a video-call room and
 * returns the join credentials (password + meet metadata). Used by
 * Sessions/{Free,Paid} + AppointmentsDetails/CallButton.
 */
export const createMeetingRoom = async (
  appointmentId: string | number
): Promise<MeetingRoomResult> => {
  const res = await instance.post<{ data: MeetingRoomResult }>(
    `${ADMIN_PREFIX}/meetings/create-room`,
    { appointmentId }
  );

  return res?.data?.data ?? ({} as MeetingRoomResult);
};
